import { type Draft, immerable } from "immer";

export class ScheduleDataState {
  [immerable] = true;
  constructor(
    public readonly startDate: Date | undefined = undefined,
    public readonly endDate: Date | undefined = undefined,
    public readonly contractsAreStale = false,
    public readonly schedulesAreStale = false,
    public readonly updatingEmployeesIds: string[] = [],
    public readonly loadingError = false,
  ) {}

  public isStale(): boolean {
    return (
      this.contractsAreStale ||
      this.schedulesAreStale ||
      this.updatingEmployeesIds.length > 0
    );
  }

  public isUpdatingEmployeeId(id: string): boolean {
    return this.updatingEmployeesIds.includes(id);
  }
}

export type ScheduleDataStateAction =
  | {
      type: "contractsAndSchedulesSetLoadingRange";
      startDate: Date;
      endDate: Date;
    }
  | { type: "contractsAndSchedulesMarkStale" }
  | { type: "schedulesMarkStale" }
  | { type: "employeesMarkStale"; employeesIds: string[] }
  | {
      type: "contractsAndSchedulesSettled";
      errorOccurred: boolean;
    };

export function reducer(
  draft: Draft<ScheduleDataState>,
  action: ScheduleDataStateAction,
): void {
  switch (action.type) {
    case "contractsAndSchedulesMarkStale": {
      draft.contractsAreStale = true;
      draft.schedulesAreStale = true;
      break;
    }
    case "contractsAndSchedulesSetLoadingRange": {
      draft.startDate = action.startDate;
      draft.endDate = action.endDate;
      draft.contractsAreStale = true;
      draft.schedulesAreStale = true;
      draft.loadingError = false;
      break;
    }
    case "schedulesMarkStale": {
      draft.schedulesAreStale = true;
      draft.loadingError = false;
      break;
    }
    case "employeesMarkStale": {
      draft.updatingEmployeesIds = [
        ...draft.updatingEmployeesIds,
        ...action.employeesIds.filter((id) => !draft.isUpdatingEmployeeId(id)),
      ];
      break;
    }
    case "contractsAndSchedulesSettled": {
      draft.loadingError = action.errorOccurred;
      draft.contractsAreStale = false;
      draft.schedulesAreStale = false;
      draft.updatingEmployeesIds = [];
      break;
    }
  }
}
